import type { ReactElement } from 'react';
import { Layout } from './layout';

const Loader = (): ReactElement => <Layout />;

export const Support = (): ReactElement => <Loader />;
